module.exports = __webpack_public_path__ + "static/images/smoothness/ui-icons_454545_256x240.png";